const isElementSelected = (value, child) => {
    const optionId = child.props.value;
    if (Array.isArray(value)) {
        return value.includes(optionId);
    }
    return value === optionId;
};
export default isElementSelected;
//# sourceMappingURL=isElementSelected.js.map